export default __webpack_public_path__ + "static/media/logoWhite.7ac9a101.svg";